import { Button, Table } from 'antd'
import React, { useEffect, useState } from 'react'
import { getCandidateTest } from '../../../controller/api/candidateServices';
import { render } from '@testing-library/react';

const CandidateTestTable = ({candidateData,setOpenCandidateReviewModal,setcandidateResponseData}) => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const columns = [
        {
          title: 'Test Name',
          dataIndex: '',
          sorter: true,
          className: 'fw-medium',
          render:(res)=>{
            return <div>{res?.testId?.name}</div>
          }
        },
        {
          title: 'Profile',
          dataIndex: '',
          sorter: true,
          className: 'fw-medium',
          render:(res)=>{
            return <div>{res?.testId?.profile}</div>
          }
        },
        {
          title: 'Score',
          dataIndex: '',
          sorter: true,
          className: 'fw-medium',
          render:(res)=>{
            return <div>{res?.totalAnswer}/{res?.totalQuestion}</div>
          }
        },
        {
          title: 'Percentage',
          dataIndex: '',
          sorter: true,
          className: 'fw-medium',
          render:(res)=>{
            return <div>{(res?.scorePoint / res?.totalPoint * 100).toFixed(2)}%</div>
          }
        },
        {
          title: 'Status',
          dataIndex: '',
          sorter: true,
          className: 'fw-medium',
          render:(res)=>{
            return   (
              <span
              className={`${
                res?.inviteId?.status == 'completed'
                  ? 'text-success'
                  : res?.inviteId?.status == 'inprogress'
                  ? 'text-warning'
                  : 'text-danger'
              }`}
          >
            {res?.inviteId?.status}
          </span>
            )
          }
          },
        {
          title: '',
          dataIndex: '',
          sorter: false,
          className: 'fw-medium',
          render:(res)=>{
           return <Button
            type='default'
            className='text-color-custom fs-6 fw-semibold btn-border-color d-flex justify-content-center align-items-center custom-hover-btn'
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenCandidateReviewModal(true);
              setcandidateResponseData(res?.userResponse);
            }}
          >
            Review Test
          </Button>
          }
        },
      ];

      useEffect(() => {
        getCandidateTest({candidateId:candidateData?._id}).then(res=>setData(res?.data)).catch(err=>{})
      }, []);
  return (
    <Table
    className='table-container'
    scroll={{
      y: 280,
      x: 600,
    }}
    columns={columns}
    rowKey={(record) => record._id}
    dataSource={data}
    // pagination={{
    //   ...tableParams.pagination,
    //   showSizeChanger: true,
    //   total: total,
    //   showTotal: (total, range) => `${range[0]}-${range[1]} of ${total}`,
    // }}
    loading={loading}
    // onChange={handleTableChange}
  />
  )
}

export default CandidateTestTable